import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginUser: {},
    activeIndex: '/board/requestStatistics',
    activityInviteStatus: ''
  },
  mutations: {
    updateLoginUser (state, loginUser) {
      // 变更状态
      state.loginUser = loginUser
    },
    updataActiveIndex (state, path) {
      // 变更状态
      state.activeIndex = path
    },
    updateActivityInviteStatus (state, activityInviteStatus) {
      state.activityInviteStatus = activityInviteStatus
    }
  },
  getters: {
    activeIndex: state => {
      return state.activeIndex
    },
    loginUser: state => {
      return state.loginUser || {}
    },
    activityInviteStatus: state => {
      return state.activityInviteStatus
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js